<template>
  <div id="app">
        <div v-if="isLoggedIn">
              <ui-tabs
                     :background-color="backgroundColor"
                     :fullwidth="fullwidth"
                     :indicator-color="indicatorColor"
                     :raised="raised"
                     :text-color-active="textColorActive"
                     :text-color="textColor"
                     :type="type"
                     :confirmTabChange="gotoPage"
                 >
                   <ui-tab
                       :key="tab.id"
                       :id="tab.id"
                       :selected="tab.id === 'Collections'"
                       :title="tab.title"

                       v-for="tab in menuTabs"
                   >
                       <ui-icon slot="icon" :icon="tab.icon"></ui-icon>

                   </ui-tab>
               </ui-tabs>
           </div>
           <div style="margin-left:10px;"><router-view/></div>

  </div>
</template>

<script>
import { HTTP } from './services/ApiService.js'

export default {
  name: 'App',
  components: {

  },
  created() {
    HTTP.interceptors.response.use((response) => {
      return response;
    },  (err) => {

      console.log("err");
      console.log(err);
      if (err.response.status === 401) {
          if(this.$route.name != "Login") {
            this.$store.dispatch('logout').then(() => this.$router.push("login"))
          } else {
            return Promise.reject(err.response);
          }
      } else {
        return Promise.reject(err.response);
      }



   });
  },
  data() {
      return {
          type: 'text',
          raised: false,
          fullwidth: false,
          backgroundColor: 'default',
          menuTabs: [
              {
                  id: 'demande',
                  title: 'Demande',
                  icon: 'person',
                  path:'/'
              },
              {
                  id: 'evenement',
                  title: 'Evenement',
                  icon: 'book',
                  path:'/evenement'
              },
              {
                  id: 'personne',
                  title: 'Personne',
                  icon: 'book',
                  path:'/personne'
              },
              {
                  id: 'user',
                  title: 'Users',
                  icon: 'book',
                  path:'/user'
              },
              {
                  id: 'logout',
                  title: 'Logout',
                  icon: 'book',
                  path:'/logout'
              },

          ],

      };
  },
  methods : {
    gotoPage(currentTab, newTab) {

              var index = this.menuTabs.findIndex(x => x.id === newTab.id);
              if(newTab.id === "logout") {
                this.$store.dispatch('logout').then(() => this.$router.push("login"))
              }

               if(index >= 0) {
                 this.$router.push(this.menuTabs[index].path);
                 return true;
               } else {
                 return false;
               }


            }
  },
  computed: {
      textColor() {
          if (this.backgroundColor === 'default') {
              return 'black';
          }
          return 'white';
      },
      textColorActive() {
          if (this.backgroundColor === 'default') {
              return 'primary';
          }
          return 'white';
      },
      indicatorColor() {
          if (this.backgroundColor === 'default') {
              return 'primary';
          }
          return 'white';
      },
      isLoggedIn() {
        return this.$store.getters.isLoggedIn
      }
  },

}
</script>

<style>
*,
*::before,
*::after {
    box-sizing: border-box;
}

html {
    font-size: 100%;
}


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
.demoTabContent {
  margin-top: 10px;
  background: rgb(233, 234, 237);
  border-radius: 5px;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 500;
}
</style>
